import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import Form from 'deltoid/core/Form';
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import { Body, Small } from 'deltoid/core/Blocks/Typography';
import { useForm, ErrorMessage } from 'react-hook-form';
import date from '@utils/date';
import FormFooter from '@components/BaseComponents/FormFooter';

import { kycActions, kycSelectors, merchantSelectors, toastActions } from '@store/ducks';

const CKYC = ({
  showToast,
  submit,
  signingAuthorityDetails,
  ckycVerifying,
  why,
}) => {
  const [ckycConsent, setCkycConsent] = useState(false);
  const { register, errors, handleSubmit, setError, reset } = useForm();

  useEffect(() => {
    const { pancard_number, name } = signingAuthorityDetails?.[0] || {};
    reset({ panNumber: pancard_number });
  }, [])

  const onSubmit = formData => {
    if (ckycConsent) {
      submit(formData.dob);
    } else {
      showToast({
        variant: 'info',
        title: 'Info',
        content: 'Please provide the consent by checking the checkbox',
      });
    }
  }
  const { name: signingAuthorityName } = signingAuthorityDetails?.[0] || {};
  return (
    <form onSubmit={handleSubmit(onSubmit)} data-testid='ckyc-dob-form'>
      <Row className='px-4'>
        <Col md={6}>
          <Form.Group>
            <Form.Label id='panNumber'>
              PAN Number of ‘{signingAuthorityName}’
            </Form.Label>
            <Form.Text
              ref={register}
              id='panNumber'
              name='panNumber'
              placeholder='e.g 1477 2890 2999'
              readOnly
            />
            <ErrorMessage errors={errors} name={'panNumber'}>
              {({ message }) => (
                <Form.Message type='error'>
                  {message}
                </Form.Message>
              )}
            </ErrorMessage>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label id='dob'>
              Date of Birth/ Date of Incorporation
            </Form.Label>
            <Form.Text
              ref={register({
                required: 'This field can not be empty',
                validate: {
                  max: v => date.isBefore(v, new Date()) || 'Invalid Date'
                }
              })}
              type='date'
              id='dob'
              name='dob'
              placeholder='e.g YYYY-MM-DD'
              className='ios-input-time'
            />
            <ErrorMessage errors={errors} name={'dob'}>
              {({ message }) => (
                <Form.Message type='error'>
                  {message}
                </Form.Message>
              )}
            </ErrorMessage>
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group>
            <div className='d-flex flex-row align-items-baseline mt-2'>
              <Form.Checkbox
                id='consent'
                name='consent'
                onChange={(e) => setCkycConsent(e.target.checked)}
              />
              <Form.Label id='consent' className='align-self-end pl-2'>
                I hereby authorize PayU Payment Pvt Ltd to pull my CKYC identifier on my behalf
                {' '}from the CKYC registry and therefore use the CKYC identifier to pull my KYC
                {' '}documents as may be available with CKYC registry
              </Form.Label>
            </div>
          </Form.Group>
        </Col>
      </Row>
      <FormFooter
        tooltipProps={why}
        btnProps={{
          label: 'Submit',
          type: "button",
          onClick: handleSubmit(onSubmit),
          disabled: ckycVerifying,
          loading: ckycVerifying
        }}
      />
    </form>
  )
};

const mapStateToProps = (state) => ({
  signingAuthorityDetails: merchantSelectors.getSigningAuthorityDetails(state),
  ckycVerifying: kycSelectors.ckycVerifying(state),
})

const mapDispatchToProps = dispatch => ({
  showToast: (toastProps) => dispatch(toastActions.show(toastProps)),
  submit: (formData) => dispatch(kycActions.fetchCKYC(formData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CKYC);